import React, { useEffect, useState } from "react"
import { Tabs, Button, Form, Row, Col, Select, Modal, message } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import PageContainer from "../../../CSIComponents/PageContainer";
import { getOTACodes } from '../../../../services/common'
import { LocalPersistence } from "../../../../factories";
import {updateRecreationDetails, deleteRecreation} from '../../../../services/recreation'
import Loading from '../../../Loading';
import '../../Table/TabpanelDetail.css'
import ActionButtonsBar from "../../../ui/ActionButtonsBar"
const { TabPane } = Tabs;
const { Option } = Select;

let newTabIndex = 10;
let newTabIndexArr: any = [];
const AccessibilityAndSecurityEdit = (props: any) => {
    const [form]: any = Form.useForm()
    const [addLoading, setAddLoading] = useState(false)
    const [typeList, setTypeList] = useState<Array<any>>([]);
    const initialPanes: any = props.editData ? props.editData : []
    const [disabledStatus, setDisabledStatus] = useState(true)
    const [requiredFlag,setRequiredFlag] = useState(true)
    initialPanes.forEach((item: any, index: number) => {
        item.closable = true;
        item.id = index;
      })
      if (initialPanes.length === 1) {
        initialPanes[0].closable = false;
      }
    const [panes, setPanels] = useState(initialPanes)
    const [addId,setAddId] = useState(panes.length);
    useEffect(() => { 
        newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
        panes.forEach((item: any, index: any) => {
            form.setFieldsValue({
                [`type-${item.detailid}`]: item.type,
                [`typedetail-${item.detailid}`]: item.typedetail,
                [`description-${item.detailid}`]: item.description,
               // [`detailid-${index}`]:item.detailid

            })
        })
        getTypeList()
        form.setFieldsValue(panes)
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [])
    const onChangeItem = ()=>{
        setRequiredFlag(true)
      }
    const getTypeList = async () => {
        // setAddLoading(true)
        let res = await getOTACodes('REC', '')
        // setAddLoading(false)
        if (res && res.otacodes && res.otacodes.length !== 0) {
            res.otacodes.map((item: any) => item.key = item.codeName)
            setTypeList(res.otacodes)
        } else {
            setTypeList([])
        }
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
          setDisabledStatus(false)
    
        }).catch(() => {
                let savelock = false
                let s = form?.getFieldsError()
                    for (let i = 0; i < s.length; i++) {
                    if(s[i].errors.length) {
                        savelock = true;
                        break
                    }
                }
                setDisabledStatus(savelock)
        })
      }
      
    useEffect(()=>{
        validateFieldsError(changeVlaue,allValue)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [panes])
    const saveClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()

        form.validateFields().then(async (value: any) => {

            // let capacityArr: any = []
            // const maxcapacityId = Object.keys(value).map((item) => { return item.split('-')[1] })
            // Array.from(new Set(maxcapacityId)).map((item) => {
            //     capacityArr.push(
            //         {
            //             type: value['type-' + item] || '',
            //             typedetail: value['typedetail-' + item] || '',
            //             description: value['description-' + item] || '',
            //         }
            //     )
            // })


            let editSecurityData = [];
            for(let key in value){
                editSecurityData.push(value[key])
            }
            let parmars = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "recreations":[
                        {
                           "recreationid":props.idInfo.recreationid,
                           "recreationlangid": props.idInfo.recreationlangid,
                           "details":editSecurityData
                        }
                     ]
                }
            }
            setAddLoading(true)
            let res = await updateRecreationDetails(parmars)
            if(res.result.success){
                setAddLoading(false)
                props.setDisabledFlag(false) 
                props.resetDetailInfo(editSecurityData)
                props.setEditToDetail()
                
            }else {
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
            setAddLoading(false)
        })
    }

   
    // props.currentLine.capacity?props.currentLine.capacity: []

    const [activeKey, setActiveKey] = useState("0")
   

    const onChange = (activeKey: any) => {
        setActiveKey(activeKey)
    };

    const onEdit = (targetKey: any, action: any) => {
        if (action === 'add') {
            add()
        } else if (action === 'remove') {
            remove(targetKey)
        }
    };

    const add = () => {
        newTabIndex = panes.length > 0 ? Number(panes.length) : 0;
        const newKey = ++newTabIndex;
        newTabIndexArr.push(newKey)
        
        const newPanes = JSON.parse(JSON.stringify(panes));
        let id = addId
        
        let obj = {id:id,closable:true,description:"",type:"",typedetail:"",detailid:newKey}
        newPanes[0].closable = true;
        newPanes.push(obj);
        id++
        setAddId(id)
        setPanels(newPanes)
        setActiveKey(JSON.stringify(newPanes.length-1))
        setRequiredFlag(true)
        // onChange(JSON.stringify(newKey-1))
    };
    const ModalHead = () => {
        return (
            <div style={{
                position: 'absolute',
                left: 0,
                top: 0,
                height: '50px',
                lineHeight: '50px',
                textIndent: '10px',
                borderBottom: '1px solid #ccc',
                color: '#fff',
                background: '#06789D',
                fontSize: 18,
                width: '100%'
            }}>Confirm</div>
        )
    }
    const remove = (targetKey: any) => {
        panes.filter((item: any,i:any) => Number(targetKey) === i)
        let daleteTitle = ""
        panes.forEach((pane: any, i: number) => {
            if (i == targetKey) {
                daleteTitle = pane.id;
            }
        });
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete Detail ${daleteTitle+1}?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk() {
                let newActiveKey = targetKey;
                let lastIndex: any;
                panes.forEach((pane: any, i: any) => {
                    if (i == targetKey) {
                        lastIndex = i - 1;
                    }
                });
                //const newPanes = JSON.parse(JSON.stringify(panes))
                // for(let i=0;i<newPanes.length;i++){
                //     if(i === Number(activeKey)){
                //         newPanes[i].type=" ";
                //     }
                // }
                const newPanes = panes.filter((pane: any,i:any) => i !== Number(targetKey));
                if (newPanes.length && newActiveKey === targetKey) {
                    if (lastIndex >= 0) {
                        newActiveKey = JSON.stringify(newPanes.length-1);
                        newTabIndex--
                    } else {
                        newActiveKey = "0";
                    }
                }
                if(newPanes.length === 0){
                    //let id = addId;
                    form.resetFields();
                    setRequiredFlag(false)
                    validateFieldsError(changeVlaue,allValue)
                    return;
                    // const newDetails = [{ 
                    //     closable:true,
                    //     "accsecurity": "",
                    //     "type": "",
                    //     "quantity": "",
                    //     "typedetail": "",
                    //     "uom": "",
                    //     "charge": "",
                    //     "currency": "",
                    //     "description": "",
                    //     'id':panes[targetKey].id
                    // }]
                    // form.setFieldsValue(newDetails)
                    // setPanels(newDetails)
                    // setActiveKey(newActiveKey)
                   
                    // setRequiredFlag(false)
                    // //id++
                    // //setAddId(id)
                    // return;
                }
                for(let i=0;i<newPanes.length;i++){
                    if(newPanes[i].type !== " "){
                        
                    }
                }
                setPanels(newPanes)
                setActiveKey(newActiveKey)
                if (newPanes.length === 1) {
                    
                    newActiveKey = '0'
                    newPanes[0].closable = false
                    setActiveKey('0')
                    
                }
            },
            onCancel() {

            },
        });
    };

    const DeleteClick = async ()=>{
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        const bodyData = {
            "supplier": session.supplier,
            "propertyId": session.propertyId,
            "property":{
            "recreations":[
                {
                   "recreationid":props.idInfo.recreationid,
                   "recreationlangid":props.idInfo.recreationlangid,
                   
                }
             ]

            }
         }
         Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete this record?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            async onOk() {
                setAddLoading(true)
                let res = await deleteRecreation(bodyData)
                   if(res.result.success){
                       setAddLoading(false)
                       props.setDisabledFlag(false)
                       panes.splice(activeKey,1)
                       props.resetDetailInfo(panes)
                       props.setEditToDetail()
                       props.cancelAndSave()
                   }
            },
            onCancel() {
      
            },
        });


         
    }
    return (
        addLoading?<Loading type="large" />:
        <>
        <PageContainer>
                <div className='editAccessibityItem' style={{ background: '#fff', padding: '20px 10px 20px 0' }} >
                    <Form
                        layout="vertical"
                        form={form}
                        name="basic"
                        //initialValues={panes}
                        onValuesChange= {validateFieldsError}
                    >
                        <Tabs
                            type="editable-card"
                            onChange={onChange}
                            activeKey={activeKey}
                            onEdit={onEdit}
                            style={{paddingLeft:'16px'}}
                            className='editAccessibitytabs'
                        >
                            {panes.map((pane: any, i: number) => (
                                 <React.Fragment key={i}>
                               {pane.type !== " "? <TabPane className='editAccessibityPane' tab={'Detail ' + (pane.id + 1)} key={i} forceRender={true}>
                                    <Row gutter={24}>
                                        <Col span={6}>
                                            <Form.Item
                                                label="Type"
                                                name = {[pane.id, 'type']}
                                            >
                                                <Select allowClear onChange={onChangeItem} showSearch>
                                                    {typeList.length > 0 && typeList.map((item: any, index: any) => {
                                                        return (
                                                            <Option key={index} value={item.codeName}>{item.codeName}</Option>
                                                        )
                                                    })}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Type Detail"
                                                name = {[pane.id, 'typedetail']}
                                                rules={[{ max: 128, message: 'You have reached the max character length of 128' }]}
                                            >
                                                <Input maxLength={128} onChange={onChangeItem} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={6}></Col>
                                    
                                        <Col span={18}>
                                            <Form.Item
                                                label="Description"
                                                name = {[pane.id, 'description']}
                                                rules={[{ max: 300, message: 'You have reached the max character length of 300' }]}
                                            >
                                                <TextArea maxLength={300} onChange={onChangeItem} rows={3} />
                                            </Form.Item>
                                        </Col>
                                       
                                    </Row>
                                </TabPane>:null}</React.Fragment>
                            ))}
                        </Tabs>
                    </Form>
                    </div>
                    <ActionButtonsBar
                        onDelete={DeleteClick}
                        onCancel={() => { props.setEditToDetail(); props.setDisabledFlag(false) }}
                        onSave={saveClick}
                        disabledSave={disabledStatus}
                        warningMsg={true}
                    />
                </PageContainer>
            
        </>
    )
}

export default AccessibilityAndSecurityEdit

function changeVlaue(changeVlaue: any, allValue: any) {
    throw new Error("Function not implemented.");
}


function allValue(changeVlaue: any, allValue: any) {
    throw new Error("Function not implemented.");
}
